import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "39",
  height: "29",
  viewBox: "0 0 39 29",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Checkmark',
  props: {
    pathClass: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("path", {
      d: "M3.45898 16.791L12.6257 25.9577L35.5423 3.04102",
      stroke: "currentColor",
      class: _normalizeClass(_ctx.pathClass),
      "stroke-width": "5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, 2)
  ]))
}
}

})